import type { FilterFn } from "@tanstack/react-table";
import type { Entry } from "../normalize";
import type { TextFilterValue } from "./types";

/**
 * Shared filterFn for every text column. Reads merged
 * `{contains, notContains}` per column. `contains` is AND-of-substrings
 * (cell must include every one); `notContains` is AND-not (cell must include
 * none). Case-insensitive. A null cell passes `notContains` (mirrors the
 * enum filter's null-passes-isNot behavior — uncategorized rows stay visible
 * when a "does not contain" chip is active).
 */
export const textFilterFn: FilterFn<Entry> = (row, columnId, raw) => {
	const f = raw as TextFilterValue | undefined;
	if (!f) return true;
	if (f.contains.length === 0 && f.notContains.length === 0) return true;
	const cell = row.getValue(columnId) as string | null;
	const haystack = cell == null ? null : cell.toLowerCase();
	if (f.contains.length > 0) {
		if (haystack == null) return false;
		for (const needle of f.contains) {
			if (!haystack.includes(needle.toLowerCase())) return false;
		}
	}
	if (haystack != null && f.notContains.length > 0) {
		for (const needle of f.notContains) {
			if (haystack.includes(needle.toLowerCase())) return false;
		}
	}
	return true;
};
